var _defs, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOvercastRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 99.5,
    x2: 232.6,
    y1: 30.7,
    y2: 261.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 52.7,
    x2: 133.4,
    y1: 9.6,
    y2: 149.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ca3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9ca3af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b7280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1381.3,
    x2: 1399.5,
    y1: -1144.7,
    y2: -1097.4,
    gradientTransform: "rotate(-9 8002.567 8233.063)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b65ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0a5ad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0950bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "h",
    x1: 1436.7,
    x2: 1454.9,
    y1: -1137,
    y2: -1089.7,
    gradientTransform: "rotate(-9 8009.537 8233.037)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "k",
    x1: 1492.1,
    x2: 1510.3,
    y1: -1129.3,
    y2: -1082.1,
    gradientTransform: "rotate(-9 8016.566 8233.078)"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    viewBox: "0 0 200.3 126.1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#848b98",
    strokeMiterlimit: 10,
    d: "M.5 93.2a32.4 32.4 0 0032.4 32.4h129.8v-.1l2.3.1a34.8 34.8 0 006.5-68.9 32.4 32.4 0 00-48.5-33 48.6 48.6 0 00-88.6 37.1h-1.5A32.4 32.4 0 00.5 93.1Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "m291 107-2.5.1A83.9 83.9 0 00135.6 43 56 56 0 0051 91a56.6 56.6 0 00.8 9A60 60 0 0063 219l4-.2v.2h224a56 56 0 000-112Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "n",
    overflow: "visible",
    viewBox: "0 0 398 222"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 200.3,
    height: 126.1,
    transform: "translate(198 27)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-9 0; 9 0; -9 0"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 350,
    height: 222
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "translate",
    values: "-18 0; 18 0; -18 0"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "o",
    overflow: "visible",
    viewBox: "0 0 129 57"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    d: "M8.5 56.5a8 8 0 01-8-8v-40a8 8 0 0116 0v40a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "f",
    additive: "sum",
    attributeName: "transform",
    begin: "0s; f.end+.33s",
    dur: ".67s",
    type: "translate",
    values: "0 -60; 0 60"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "g",
    attributeName: "opacity",
    begin: "0s; g.end+.33s",
    dur: ".67s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    d: "M64.5 56.5a8 8 0 01-8-8v-40a8 8 0 0116 0v40a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "i",
    additive: "sum",
    attributeName: "transform",
    begin: ".33s; i.end+.33s",
    dur: ".67s",
    type: "translate",
    values: "0 -60; 0 60"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "j",
    attributeName: "opacity",
    begin: ".33s; j.end+.33s",
    dur: ".67s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    d: "M120.5 56.5a8 8 0 01-8-8v-40a8 8 0 0116 0v40a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "l",
    additive: "sum",
    attributeName: "transform",
    begin: "-.33s; l.end+.33s",
    dur: ".67s",
    type: "translate",
    values: "0 -60; 0 60"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "m",
    attributeName: "opacity",
    begin: "-.33s; m.end+.33s",
    dur: ".67s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    width: 398,
    height: 222,
    transform: "translate(68.84 145)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    width: 129,
    height: 57,
    transform: "translate(191.5 343.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvercastRain);
export default __webpack_public_path__ + "static/media/overcast-rain.f0b28f162e9e69273925caed937405e3.svg";
export { ForwardRef as ReactComponent };